/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AdultTpnStartAliases {
  ADULT_TPN_START_ACCORDION = 'adult-tpn-start-accordion',
  ADULT_TPN_START_ACCORDION_PANEL = 'adult-tpn-start-accordion-panel',
  ADULT_TPN_START_ACCORDION_PLUS_TITLE_PANEL = 'adult-tpn-start-accordion-plus-title-panel',
  ADULT_TPN_START_ACCORDION_PLUS_TITLE_TEXT = 'adult-tpn-start-accordion-plus-title-text',
  ADULT_TPN_START_ACCORDION_TITLE_PANEL = 'adult-tpn-start-accordion-title-panel',
  ADULT_TPN_START_ACCORDION_TITLE_TEXT = 'adult-tpn-start-accordion-title-text',
  ADULT_TPN_START_BARCODE = 'adult-tpn-start-barcode',
  ADULT_TPN_START_BARCODE_PANEL = 'adult-tpn-start-barcode-panel',
  ADULT_TPN_START_BUTTON = 'adult-tpn-start-button',
  ADULT_TPN_START_BUTTON_PANEL_PADDING = 'adult-tpn-start-button-panel-padding',
  ADULT_TPN_START_CARD = 'adult-tpn-start-card',
  ADULT_TPN_START_CARD_DECK = 'adult-tpn-start-card-deck',
  ADULT_TPN_START_CARD_PANEL = 'adult-tpn-start-card-panel',
  ADULT_TPN_START_CARDS_ACCORDION = 'adult-tpn-start-cards-accordion',
  ADULT_TPN_START_CARDS_ACCORDION_PANEL = 'adult-tpn-start-cards-accordion-panel',
  ADULT_TPN_START_CONTENT_PANEL = 'adult-tpn-start-content-panel',
  ADULT_TPN_START_DATE_TIME_FIELD = 'adult-tpn-start-date-time-field',
  ADULT_TPN_START_DATE_TIME_TEXT = 'adult-tpn-start-date-time-text',
  ADULT_TPN_START_DEVICE_AUTOCOMPLETE = 'adult-tpn-start-device-autocomplete',
  ADULT_TPN_START_DEVICE_FETCH = 'adult-tpn-start-device-fetch',
  ADULT_TPN_START_DEVICE_FIELD = 'adult-tpn-start-device-field',
  ADULT_TPN_START_DEVICE_MAPPER = 'adult-tpn-start-device-mapper',
  ADULT_TPN_START_DEVICE_TEXT = 'adult-tpn-start-device-text',
  ADULT_TPN_START_FORM = 'adult-tpn-start-form',
  ADULT_TPN_START_INFUSION_FORM_AUTOCOMPLETE = 'adult-tpn-start-infusion-form-autocomplete',
  ADULT_TPN_START_INFUSION_FORM_FETCH = 'adult-tpn-start-infusion-form-fetch',
  ADULT_TPN_START_INFUSION_FORM_FIELD = 'adult-tpn-start-infusion-form-field',
  ADULT_TPN_START_INFUSION_FORM_MAPPER = 'adult-tpn-start-infusion-form-mapper',
  ADULT_TPN_START_INFUSION_FORM_TEXT = 'adult-tpn-start-infusion-form-text',
  ADULT_TPN_START_INFUSION_SPEED_FIELD = 'adult-tpn-start-infusion-speed-field',
  ADULT_TPN_START_INFUSION_SPEED_INPUT = 'adult-tpn-start-infusion-speed-input',
  ADULT_TPN_START_LAYOUT = 'adult-tpn-start-layout',
  ADULT_TPN_START_NAME_DATE_PANEL = 'adult-tpn-start-name-date-panel',
  ADULT_TPN_START_NAME_FIELD = 'adult-tpn-start-name-field',
  ADULT_TPN_START_NAME_TEXT = 'adult-tpn-start-name-text',
  ADULT_TPN_START_NEW_DATE_FIELD = 'adult-tpn-start-new-date-field',
  ADULT_TPN_START_NEW_DATE_INPUT = 'adult-tpn-start-new-date-input',
  ADULT_TPN_START_OBSERVATION_TEXT = 'adult-tpn-start-observation-text',
  ADULT_TPN_START_TEXT_OBSERVATION_FIELD = 'adult-tpn-start-text-observation-field',
  ADULT_TPN_START_UNITY_AUTOCOMPLETE = 'adult-tpn-start-unity-autocomplete',
  ADULT_TPN_START_UNITY_FETCH = 'adult-tpn-start-unity-fetch',
  ADULT_TPN_START_UNITY_FIELD = 'adult-tpn-start-unity-field',
  ADULT_TPN_START_UNITY_MAPPER = 'adult-tpn-start-unity-mapper',
  ADULT_TPN_START_UNITY_TEXT = 'adult-tpn-start-unity-text',
  ADULT_TPN_START_VOLUME_STEP_FIELD = 'adult-tpn-start-volume-step-field',
  ADULT_TPN_START_VOLUME_STEP_INPUT = 'adult-tpn-start-volume-step-input',
  GLOBAL_ACTIONS = 'global-actions',
  LEGENDS_ADULT_TPN_START = 'legends-adult-tpn-start',
}
export { AdultTpnStartAliases };
